import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { CacheApi } from "../../api/CacheApi";
import type { CacheStatusStaff } from "../../generated/dto/CacheStatusStaff";
import type { DeleteCacheStatusStaff } from "../../generated/dto/DeleteCacheStatusStaff";

export class CacheApiClient implements CacheApi {
  constructor(private readonly client = useClient()) {}

  async getCacheStatusStaff(id: number): Promise<CacheStatusStaff> {
    const { data } = await this.client.get<unknown>(`/cachestatus/staff/${id}`);
    return deserializeCbiDto<CacheStatusStaff>(data, "generated.dto.CacheStatusStaff");
  }

  async deleteCacheStatusStaff(source: DeleteCacheStatusStaff): Promise<void> {
    await this.client.delete(`/cachestatus/staff/${source.cacheStatusId}`);
  }
}

export const useCacheApi = (): CacheApi => new CacheApiClient();
